import cn from 'classnames';
import CmsIcon from 'components/cms-icon';
import { IPromoBarSmallFields } from 'global';
import useIsClient from 'hooks/common/use-is-client';
import useMobile from 'hooks/common/use-mobile';
import Link from 'next/link';

/**
 * This componenyt renders a small promo bar on the top of the landing pages (Dogs & Cats).
 * It is only rendered on mobile devices and can be configured in Contentful and personalised via Ninetailed.
 */
const PromoBarSmallComponent: React.FC<IPromoBarSmallFields> = ({
  border,
  color,
  customIcon,
  enabled,
  icon,
  iconColor = '#19335A',
  link,
  promoImageMobile,
  text,
  textColor = '#19335A',
}) => {
  const isMobile = useMobile();
  const { isClient } = useIsClient();

  if (!enabled || !isMobile || !isClient) return null;

  const content = (
    <div>
      {promoImageMobile && (
        <img
          className="w-full"
          src={promoImageMobile.fields.file.url}
          alt={promoImageMobile.fields.title}
        />
      )}

      <div
        className={cn(
          `flex items-center justify-center p-2 bg-new-brand-soft-${color}`,
          border && `ring-3 ring-new-brand-${color} ring-inset`
        )}
      >
        {icon && !customIcon && (
          <div className={`bg-new-brand-${color} mr-2 flex rounded-full p-3`}>
            <CmsIcon
              iconName={icon}
              svgAttributes={{
                className: 'w-6 h-6',
                color: iconColor,
              }}
            />
          </div>
        )}

        {customIcon && (
          <div className={`bg-new-brand-${color} mr-2 rounded-full p-3`}>
            <img
              src={customIcon.fields.file.url}
              alt={customIcon.fields.title}
              style={{ color: textColor }}
              className="h-6 w-6"
            />
          </div>
        )}

        <span
          style={{ color: textColor }}
          className={cn(
            'mt-1 line-clamp-1 text-center text-xl font-black',
            icon || customIcon ? 'max-w-xs' : 'max-w-full'
          )}
        >
          {text}
        </span>
      </div>
    </div>
  );

  const wrapper = link ? <Link href={link} legacyBehavior>{content}</Link> : <>{content}</>;

  return wrapper;
};

export default PromoBarSmallComponent;
